/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccc_CopyrightInputs */

const en_ccc_copyright = /** @type {(inputs: Ccc_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`© 2020-2025 Closed Caption Creator Inc. All rights reserved.`)
};

const fr_ccc_copyright = /** @type {(inputs: Ccc_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`© 2020-2025 Closed Caption Creator Inc. Tous droits réservés.`)
};

const de_ccc_copyright = /** @type {(inputs: Ccc_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`© 2020-2025 Closed Caption Creator Inc. Alle Rechte vorbehalten.`)
};

const it_ccc_copyright = /** @type {(inputs: Ccc_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`© 2020-2025 Closed Caption Creator Inc. Tutti i diritti riservati.`)
};

const ru_ccc_copyright = /** @type {(inputs: Ccc_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`© 2020-2025 Closed Caption Creator Inc. Все права защищены.`)
};

const es_ccc_copyright = /** @type {(inputs: Ccc_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`© 2020-2025 Closed Caption Creator Inc. Todos los derechos reservados.`)
};

const zh_cn2_ccc_copyright = /** @type {(inputs: Ccc_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`© 2020-2025 Closed Caption Creator Inc. 保留所有权利。`)
};

const ja_ccc_copyright = /** @type {(inputs: Ccc_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`© 2020-2025 Closed Caption Creator Inc. 無断複写・転載を禁じます。`)
};

const hi_ccc_copyright = /** @type {(inputs: Ccc_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`© 2020-2025 क्लोज्ड कैप्शन क्रिएटर इंक. सर्वाधिकार सुरक्षित।`)
};

const pt_pt2_ccc_copyright = /** @type {(inputs: Ccc_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`© 2020-2025 Closed Caption Creator Inc. Todos os direitos reservados.`)
};

/**
* | output |
* | --- |
* | "© 2020-2025 Closed Caption Creator Inc. All rights reserved." |
*
* @param {Ccc_CopyrightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccc_copyright = /** @type {((inputs?: Ccc_CopyrightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccc_CopyrightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccc_copyright(inputs)
	if (locale === "de") return de_ccc_copyright(inputs)
	if (locale === "it") return it_ccc_copyright(inputs)
	if (locale === "ru") return ru_ccc_copyright(inputs)
	if (locale === "es") return es_ccc_copyright(inputs)
	if (locale === "zh-CN") return zh_cn2_ccc_copyright(inputs)
	if (locale === "ja") return ja_ccc_copyright(inputs)
	if (locale === "hi") return hi_ccc_copyright(inputs)
	if (locale === "pt-PT") return pt_pt2_ccc_copyright(inputs)
	return en_ccc_copyright(inputs)
});